import { CategoryVisibility } from '../types/clientCategory';

export const VisibilityPresets = {
  onlineOnly: {
    ONLINE_ONLY_NON_RMS: true,
    ONLINE_ONLY_RMS: true,
    POS_ONLY: false,
    BOTH_ONLINE_AND_POS: false,
  },
  flipdishOnlineOnly: {
    ONLINE_ONLY_NON_RMS: true,
    ONLINE_ONLY_RMS: false,
    POS_ONLY: false,
    BOTH_ONLINE_AND_POS: false,
  },
  rmsRequired: {
    ONLINE_ONLY_NON_RMS: false,
    ONLINE_ONLY_RMS: true,
    POS_ONLY: true,
    BOTH_ONLINE_AND_POS: true,
  },
  anyWithOnline: {
    ONLINE_ONLY_NON_RMS: true,
    ONLINE_ONLY_RMS: true,
    POS_ONLY: false,
    BOTH_ONLINE_AND_POS: true,
  },
  posOnly: {
    ONLINE_ONLY_NON_RMS: false,
    ONLINE_ONLY_RMS: false,
    POS_ONLY: true,
    BOTH_ONLINE_AND_POS: true,
  },
} as const satisfies Record<string, CategoryVisibility>;
